import { Button, CommonErrors, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, usePopup, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    BASE,
    APIS,
    URLS,
    SG_VRFN_CTRA_BULK_LIST,
    SF_VRFN_CTRA_BULK_INFO,
} from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";

/*
 * Collective registration of common verification criteria items
 * !== 검증기준정보일괄등록 ==!
 */
export const PTLI0413004S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const modal = useModal();
    const { getParams } = usePopup();
    const { dclaDocCd } = getParams();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        vrfnCtraBulkInfo: useForm({
            defaultSchema: SF_VRFN_CTRA_BULK_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        vrfnCtraBulkList: useGrid({
            defaultSchema: SG_VRFN_CTRA_BULK_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        insertVrfnCtraBulkList: useFetch({
            api: (data) => APIS.insertVrfnCtraBulkList(data),
            onSuccess: (data) => {
                if (data?.msgList?.content.length > 0) {
                    // 일반 메시지 모달
                    modal.openModal({
                        type: "messages",
                        data: data?.msgList.content,
                    });
                } else {
                    modal.openModal({
                        content: "msg.00003",
                        onCancel: () => {
                            modal.closeModal();
                            // navigate(`${URLS.ptli0801001q}?menuId=${menuId}`);
                        },
                    });
                }
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        insertVrfnCtraBulkList: form.vrfnCtraBulkInfo.handleSubmit(
            () => {
                // 그리드 오류검증 실행
                const errors = grid.vrfnCtraBulkList.validate();

                // 오류가 존재하는 경우
                if (errors) {
                    // 공통 오류팝업창에 해당 오류 내용을 표시
                    modal.openModal({
                        content: <CommonErrors {...errors} />,
                        draggable: true,
                        size: "lg",
                    });
                    return;
                }

                const data = form.vrfnCtraBulkInfo.getValues();
                data.vrfnCtraBulkList = grid.vrfnCtraBulkList.getData();
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.insertVrfnCtraBulkList.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    useEffect(() => {
        form.vrfnCtraBulkInfo.setValue("dclaDocCd", dclaDocCd);
    }, []);

    return (
        <Page id={pgeUid} title={t("T_VRFN_CTRA_INFO")}>
            <Group>
                <Group.Body>
                    <Layout>
                        <Button
                            role="tmplDown"
                            onClick={() => {
                                comnUtils.downloadTemplate("1b4d68e4-763d-24c0-e063-020011ac8602");
                            }}
                        ></Button>
                        <Button
                            role="excelUpload"
                            onClick={async () => {
                                const excelData = await grid.vrfnCtraBulkList.importExcel();
                                grid.vrfnCtraBulkList.setData(comnUtils.getGridData(excelData));
                                grid.vrfnCtraBulkList.validate();
                            }}
                        ></Button>
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.vrfnCtraBulkList.grid} />
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"save"} onClick={handler.insertVrfnCtraBulkList} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
